import { useState, useEffect } from "react";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("gs_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (value) => {
    localStorage.setItem("gs_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4" data-testid="cookie-banner">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.15)] border border-[#f1eee6] p-6">
        {!showDetails ? (
          <>
            <div className="flex items-start justify-between gap-4 mb-4">
              <div>
                <h3 className="text-base font-semibold text-[#111] mb-1" style={{fontFamily: 'var(--font-sans)'}}>Bonjour c'est nous... Les Cookies</h3>
                <p className="text-sm text-[#555] leading-relaxed">
                  Notre role est de contribuer a l'analyse du trafic et au bon fonctionnement de ce site. C'est OK pour vous ?
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              <button
                data-testid="cookie-consent-choose-button"
                onClick={() => setShowDetails(true)}
                className="btn-gold-outline text-xs px-4 py-2"
              >
                Je choisis
              </button>
              <button
                data-testid="cookie-consent-deny-button"
                onClick={() => handleConsent("denied")}
                className="btn-gold-outline text-xs px-4 py-2"
              >
                Non
              </button>
              <button
                data-testid="cookie-consent-accept-button"
                onClick={() => handleConsent("accepted")}
                className="btn-primary text-xs px-4 py-2"
              >
                Ok pour moi
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base font-semibold text-[#111]" style={{fontFamily: 'var(--font-sans)'}}>Choisis ce qu'on peut analyser</h3>
              <button onClick={() => setShowDetails(false)} className="text-[#999]" aria-label="Fermer">
                <X className="w-4 h-4" />
              </button>
            </div>
            <p className="text-sm text-[#555] mb-4">
              Nous sommes charges d'analyser le trafic de ce site. Grace a nous, il peut etre ameliore pour vous proposer la meilleure experience possible.
            </p>
            <div className="space-y-3 mb-4">
              <div className="flex items-center justify-between py-2 border-b border-[#f1eee6]">
                <span className="text-sm font-medium text-[#111]">Necessaires</span>
                <span className="text-xs text-green-600 font-medium">Toujours actifs</span>
              </div>
              <div className="flex items-center justify-between py-2 border-b border-[#f1eee6]">
                <span className="text-sm font-medium text-[#111]">Analytiques</span>
                <input type="checkbox" className="rounded" defaultChecked />
              </div>
              <div className="flex items-center justify-between py-2 border-b border-[#f1eee6]">
                <span className="text-sm font-medium text-[#111]">Performance</span>
                <input type="checkbox" className="rounded" />
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => handleConsent("denied")}
                className="btn-gold-outline text-xs px-4 py-2"
              >
                Non
              </button>
              <button
                onClick={() => handleConsent("partial")}
                className="btn-gold-outline text-xs px-4 py-2"
              >
                Enregistre mon choix
              </button>
              <button
                onClick={() => handleConsent("accepted")}
                className="btn-primary text-xs px-4 py-2"
              >
                Ok pour moi
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
